import type { AppRouteDefinition } from './routes';

type FeatureFlagMap = Partial<Record<string, boolean>>;

export const filterRoutesByFeatureFlags = (
  routes: AppRouteDefinition[],
  flags: FeatureFlagMap | null,
): AppRouteDefinition[] => {
  if (!flags) return routes;
  return routes.filter((route) => {
    if (!route.featureFlag) return true;
    const enabled = flags[route.featureFlag];
    return enabled ?? false;
  });
};

export const resolveRoutesForFeatureFlags = (
  routes: AppRouteDefinition[],
  flags: FeatureFlagMap | null,
  loading: boolean,
): AppRouteDefinition[] => {
  if (loading) return routes;
  return filterRoutesByFeatureFlags(routes, flags);
};

export const getFeatureFlagKeys = (
  routes: AppRouteDefinition[],
  extraKeys: string[] = [],
): string[] => {
  const keys = new Set<string>(extraKeys);
  routes.forEach((route) => {
    if (route.featureFlag) {
      keys.add(route.featureFlag);
    }
  });
  return Array.from(keys);
};
